import * as React from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { NavItem } from './TopBar';
import Stack from '@mui/material/Stack';
import { Box } from '@mui/material';
import { makeStyles} from '@mui/styles'
import { usePermission } from '@backstage/plugin-permission-react';
import { costPermission } from '../cost/permission';

const useStyles = makeStyles(theme => ({
  
  list:{
    backgroundColor:theme.palette.mode === 'dark' ? '#444444' : '#000000',
  },
  hover:{
    color:"#FFFFFF",
    '&:hover':{
      background: theme.palette.navigation.navItem?.hoverBackground || '#404040',
      cursor: "pointer",
    }

  
  }
}));

export default function ToolsMenu() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const { allowed } = usePermission({ permission: costPermission });
  

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current!.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    
    <Stack direction="column" spacing={2} zIndex={150}>
      <Box className={classes.hover}>
        <Box
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? 'composition-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          sx={{ py:2, px:4}}
          className={classes.hover}
        >
          TOOLS
        </Box>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom-start' ? 'left top' : 'left bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                    className={classes.list}
                  >
                    <MenuItem onClick={handleClose}><NavItem to="tech-radar" text="Tech Radar" /></MenuItem>
                    {allowed && <MenuItem onClick={handleClose}><NavItem to="cost" text="Cost Insights" /></MenuItem>}
                    
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Box>
    </Stack>
    
  );
}